/* 🤖 this file was generated by svg-to-ts */
export const DfIconGoogleSquare16: {
  name: 'google-square-16';
  data: string;
} = {
  name: 'google-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm6.008 4A4.004 4.004 0 0 0 4 8c0 2.21 1.794 4 4.008 4 1.442 0 2.277-.445 3.003-1.169.725-.724.989-1.819.989-2.923a4.32 4.32 0 0 0-.03-.502H8.057V8.82h2.298c-.093.353-.252.674-.501.923-.447.446-.961.72-1.85.72A2.465 2.465 0 0 1 5.538 8a2.465 2.465 0 0 1 2.468-2.463c.663 0 1.24.19 1.698.601l1.129-1.107-.002-.001C10.077 4.32 9.115 4 8.008 4z"/></svg>`
};
